/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Select_BothInputs */

const en_cover_letters_select_both = /** @type {(inputs: Cover_Letters_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and resume`)
};

const de_cover_letters_select_both = /** @type {(inputs: Cover_Letters_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle sowohl eine Stelle als auch einen Lebenslauf`)
};

const fr_cover_letters_select_both = /** @type {(inputs: Cover_Letters_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionne à la fois un emploi et un CV`)
};

const es_cover_letters_select_both = /** @type {(inputs: Cover_Letters_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione tanto un empleo como un currículum`)
};

const it_cover_letters_select_both = /** @type {(inputs: Cover_Letters_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona sia un lavoro che un curriculum`)
};

const nl_cover_letters_select_both = /** @type {(inputs: Cover_Letters_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer zowel een baan als een CV`)
};

const pl_cover_letters_select_both = /** @type {(inputs: Cover_Letters_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz zarówno ofertę pracy, jak i CV`)
};

const fi_cover_letters_select_both = /** @type {(inputs: Cover_Letters_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse sekä työpaikka että ansioluettelo`)
};

const da_cover_letters_select_both = /** @type {(inputs: Cover_Letters_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg både et job og CV`)
};

const sv_cover_letters_select_both = /** @type {(inputs: Cover_Letters_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj både ett jobb och CV`)
};

/**
* | output |
* | --- |
* | "Select both a job and resume" |
*
* @param {Cover_Letters_Select_BothInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_select_both = /** @type {((inputs?: Cover_Letters_Select_BothInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Select_BothInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_select_both(inputs)
	if (locale === "fr") return fr_cover_letters_select_both(inputs)
	if (locale === "es") return es_cover_letters_select_both(inputs)
	if (locale === "it") return it_cover_letters_select_both(inputs)
	if (locale === "nl") return nl_cover_letters_select_both(inputs)
	if (locale === "pl") return pl_cover_letters_select_both(inputs)
	if (locale === "fi") return fi_cover_letters_select_both(inputs)
	if (locale === "da") return da_cover_letters_select_both(inputs)
	if (locale === "sv") return sv_cover_letters_select_both(inputs)
	return en_cover_letters_select_both(inputs)
});